/**
 * KbdHint — small kbd glyph used in rows + the footer.
 *
 * Single source of truth so a shortcut rendered in the search row matches
 * the look of one in the footer. Use `keys` for multi-key combos:
 *   <KbdHint keys={["⌘", "K"]} />
 */
"use client";

import { cn } from "@/shared/lib/utils";

interface KbdHintProps {
  keys: string[];
  className?: string;
}

export function KbdHint({ keys, className }: KbdHintProps) {
  if (keys.length === 0) return null;
  return (
    <span className={cn("inline-flex items-center gap-0.5", className)}>
      {keys.map((k, i) => (
        <kbd
          key={i}
          className="rounded-sm border border-border bg-background px-1.5 py-0.5 font-mono text-micro leading-none text-muted-foreground"
        >
          {k}
        </kbd>
      ))}
    </span>
  );
}

/** Parse a shortcut string like "⌘ ⇧ N" or "Cmd+Shift+N" into an array. */
export function parseShortcut(s: string): string[] {
  return s
    .split(/[+\s]+/)
    .map((k) => k.trim())
    .filter(Boolean);
}
